export interface DialPhoneRequest {
  phoneNumber: string;
  skillId: number;
  parentContactId?: number;
}
